// extracted by mini-css-extract-plugin
export var li = "timelinemenu-module--li--p7B59";
export var list = "timelinemenu-module--list--l92oA";
export var listDate = "timelinemenu-module--list-date--ivDUm";
export var listPeriod = "timelinemenu-module--list-period--gJ+dk";
export var timelineMenu = "timelinemenu-module--timelineMenu--FtmdT";
export var timelinieUl = "timelinemenu-module--timelinie-ul--fzKbX";